<template src='./bankStatement.pug' lang='pug'></template>

<script>
import moment from 'moment'
import GridDetailsModal from '../../../modals/gridDetailsModal/GridDetailsModal'
import MultiSelectModal from '../../../modals/multiSelectModal/MultiSelectModal'
import PageTitle from '../../../layout/pageTitle/PageTitle'
import FilterPortlet from '../../../layout/filterPortlet/FilterPortlet'
import FormSearch from '../../../form/formSearch/FormSearch'
import DateRange from '../../../input/dateRange/DateRange'
import BetterInputTag from '../../../input/betterInputTag/BetterInputTag'
import ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'
import TreeGrid from '../../../treeGrid/TreeGrid'
import axios from '../../../../../build/http-requests/axios-common.js'
import { EXPORT_TREEGRID } from '../../../../../build/jsonToExcel/exportRoutes.js'
import language from '../../../../../build/language/index'
import { trackAnalyticsEvent } from '../../../../utils/analytics.js'
import { startTreeGridLoading, stopTreeGridLoading } from '../../../../utils/grid-load-transition.js'
import { generateBankStatFromRow } from '../../../../utils/transformationData.js'
import closeModal from '../../../../events/closeModal'
import FunctionalitieIdEnum from '../../../../enum/funcionalidadeId'

export default {
  name: 'BankStatement',

  components: {
    GridDetailsModal,
    MultiSelectModal,
    PageTitle,
    FilterPortlet,
    FormSearch,
    DateRange,
    BetterInputTag,
    ButtonPrimary,
    TreeGrid
  },

  data () {
    return {
      groupingOptions: {
        prop: 'grupo.id',
        groupIdProp: 'id',
        headerNameProp: 'nome',
        defaultIdGroup: '0'
      },
      groups: [],
      titleModal: this.$t('extratoBancario.labels.contasBancarias'),
      subTitleModal: this.$t('extratoBancario.labels.selecionarContasBancarias'),
      gridId: '#ExtratoConta',
      BANK_ACCOUNT_MODAL: 'bankAccountsModal',
      audit: {},
      dateRange: {},
      itensSelected: [],
      list: [],
      selectedList: [],
      selectModal: null,
      allItensSelected: null,
      bankAccountsSelected: [],
      bankAccountsTags: [this.$t('inputTag.labels.todos')],
      firstDate: new Date(),
      finalDate: new Date(),
      finalDateDisable: moment(new Date()).add(10, 'years').toDate(),
      showTreegrid: false,
      exportUrl: EXPORT_TREEGRID,
      filter: {
        entityId: null
      },
      result: {},
      treeGridFileName: 'ExtratoBancario',
      error: false,
      msgError: '',
      dataTableColumns: [],
      disableSearchButton: false,
      detailsObj: {
        mainValuesList: [],
        monetaryValuesList: [],
        integrationValuesList: [],
        classificationValuesList: [],
        idProcessamento: -1
      },
      bankStatGridModalId: '',
      isOpenDetailsModal: false,
      columnsClasses: {},
      orderBy: {},
      headings: {},
      templates: {},
      customSorting: {},
      sortable: [],
      firstTime: true,
      modalDetailsTabs: [],
      filterable: ['nome'],
      showCustomColumns: false,
      treeGridCfg: {},
      isExportFile: false,
      inputTagsProps: {
        bankAccounts: {
          id: 'id',
          name: 'nome'
        }
      },
      shown: {
        bankAccounts: false
      },
      defaultTags: {
        bankAccounts: [{
          id: '-1',
          nome: this.$t('inputTag.labels.todos')
        }]
      },
      data: {
        bankAccounts: {
          titles: {
            main: this.$t('extratoBancario.labels.contasBancarias'),
            sub: this.$t('extratoBancario.labels.selecionarContasBancarias')
          },
          allBankAccounts: [],
          showToggleInactiveAccounts: false,
          selectedItems: [],
          considerInactiveAccounts: false,
          columns: ['nome', 'banco', 'numAgencia', 'conta'],
          values: [],
          options: {
            columnsClasses: { nome: 'col-md-3', banco: 'col-md-4', numAgencia: 'col-md-2', conta: 'col-md-3' },
            perPage: 5,
            headings: {
              nome: this.$t('contaBancaria.labels.nome'),
              banco: this.$t('contaBancaria.labels.banco'),
              numAgencia: this.$t('contaBancaria.labels.agencia'),
              conta: this.$t('contaBancaria.labels.numeroConta')
            },
            filterable: ['nome', 'banco', 'numAgencia', 'conta'],
            filterByColumn: true,
            perPageValues: [],
            texts: {
              count: this.$t('dataTable.labels.contagem'),
              noResults: this.$t('dataTable.labels.semResultados'),
              filterBy: '',
              filterPlaceholder: this.$t('dataTable.labels.filtrar')
            },
            sortable: ['nome', 'banco', 'numAgencia', 'conta'],
            sortIcon: {
              is: ''
            },
            pagination: { chunk: 5 },
            orderBy: {
              ascending: true,
              column: 'nome'
            },
            customSorting: {
              nome: (asc) => {
                return (a, b) => {
                  if (asc) {
                    return a.nome.toLowerCase().localeCompare(b.nome.toLowerCase())
                  }
                  return b.nome.toLowerCase().localeCompare(a.nome.toLowerCase())
                }
              },
              banco: (asc) => {
                return (a, b) => {
                  if (asc) {
                    return a.banco.codigo <= b.banco.codigo ? 1 : -1
                  }
                  return a.banco.codigo >= b.banco.codigo ? 1 : -1
                }
              },
              agencia: (asc) => {
                return (a, b) => {
                  if (asc) {
                    return a.numAgencia <= b.numAgencia
                  }
                  return a.numAgencia >= b.numAgencia
                }
              },
              conta: (asc) => {
                return (a, b) => {
                  if (asc) {
                    return +a.conta >= +b.conta ? 1 : -1
                  }
                  return +a.conta <= +b.conta ? 1 : -1
                }
              }
            },
            templates: {
              nome: (h, row) => {
                let txt = row.nome
                if (!row.ativo) {
                  txt += ' (' + this.$t('contaBancaria.labels.inativa') + ')'
                }
                return txt
              },
              banco: (h, row) => {
                if (row.banco) {
                  return row.banco.codigo + '-' + row.banco.nome
                }
                return '-'
              },
              agencia: (h, row) => {
                let txt = '-'
                if (row.agencia) {
                  txt = row.numAgencia
                  if (row.digAgencia) {
                    txt += '-' + row.digAgencia
                  }
                }
                return txt
              },
              conta: (h, row) => {
                let txt = row.conta
                if (row.digConta) {
                  txt += '-' + row.digConta
                }
                return txt
              }
            }
          }
        }
      },
      queryNotClassif: true,
      queryOnlyClassif: true
    }
  },

  methods: {
    getLoadingMessages () {
      return this.isExportFile ? ['geral.loading.andamento', 'geral.loading.preparandoArquivo'] : ['geral.loading.andamento', 'geral.loading.preparandoGrid']
    },

    validate () {
      let self = this
      let promise = null
      return new Promise(resolve => {
        self.$validator.validateAll().then((result) => {
          if (result && this.$refs.dateRange.validate()) {
            if (self.isExportFile) {
              promise = self.download()
            } else {
              self.showTreegrid = true
              startTreeGridLoading(self.gridId, self.getLoadingMessages())
              promise = self.search()
            }
            promise.finally(() => {
              resolve()
            })
          } else {
            resolve()
          }
        })
      })
    },

    mountFilters () {
      this.disableSearchButton = true
      let filter = {
        inicio: this.dateRange.fromDate,
        fim: this.dateRange.toDate,
        idsContas: this.data.bankAccounts.selectedItems.map(selected => selected.id).filter(account => account !== '-1'),
        considerarContasInativas: this.data.bankAccounts.considerInactiveAccounts,
        lang: language.getCookieByName('language'),
        considerarClassificacao: this.queryNotClassif && !this.queryOnlyClassif ? 0 // consulta apenas nao classificados
          : (
            !this.queryNotClassif && this.queryOnlyClassif ? 1 // consulta apenas classificados
            : 2 // default consulta por todos
          )
      }
      return filter
    },

    download () {
      return new Promise((resolve, reject) => {
        this.$store.dispatch('searchBankStatementToFile', { filter: this.mountFilters() })
        .then(() => {
          this.disableSearchButton = false
          resolve()
        }).catch((error) => {
          this.error = true
          this.msgError = error.body
          this.$root.$refs.notification.error('GENERAL')
          this.disableSearchButton = false
          reject()
        })
      })
    },

    search () {
      return new Promise((resolve, reject) => {
        axios.post('/bankStatement/', { filter: this.mountFilters() }).then((response) => {
          response.data.Body.forEach(e => {
            e._isVue = true
          })
          if (window.Grids[0]) {
            window.DisposeGrids()
          }
          this.result = response.data
          response.data.Body.forEach(bodyList => {
            bodyList.forEach(item => {
              if (item.NomeEstabelecimentoGrupo === '') {
                item.NomeEstabelecimentoGrupo = this.$t('contaBancaria.labels.semGrupo')
              }
              if (item.CritClassif === '') {
                item.CritClassif = this.$t('extratoBancario.labels.naoClassificado')
              }
            })
          })
          this.treeGridCfg = this.result && this.result.Cfg ? this.result.Cfg.Layout : {}
          // Quando a resposta nao possuir saldo anterior, altera a configuracao da treegrid para exibir a mensagem correta.
          if (this.result && this.result.Solid[0]) {
            const valorAnterior = this.result.Solid[0].VlSaldoAnterior
            if (valorAnterior == null) {
              this.treeGridCfg.Solid[2].DsHistorico = this.$t('extratoBancario.labels.saldoVazio').replace('{DIA_ANTERIOR}', moment(this.result.Solid[0].DtLanc).format('DD/MM/YYYY'))
              this.treeGridCfg.Solid[2].Cells = 'DsHistorico'
            } else {
              this.treeGridCfg.Solid[2].DsHistorico = this.treeGridCfg.Solid[2].DsHistorico.replace('{DIA_ANTERIOR}', moment(this.result.Solid[0].DtLanc).format('DD/MM/YYYY'))
            }
          }
          this.showTreegrid = true
          window.Grids.abrirModalDetalhes = (row) => {
            this.bankStatGridModalId = 'bankStatGridModalIdMov-' + row.IdLancamento
            trackAnalyticsEvent(this, 'row-click', 'extrato-bancario-grid-details', row.IdLancamento)
            this.detailsObj = generateBankStatFromRow(row)
            this.generateModalTabs()
            setTimeout(() => {
              this.showDetailsModal()
              window.Grids[0].Disable()
            }, 100)
          }
          this.showTreegrid = true
          stopTreeGridLoading(this.gridId)

          if (!this.queryNotClassif && this.queryOnlyClassif) { // Caso consulta seja apenas por lancamentos classificados, aplica agrupamento especifico
            setTimeout(() => {
              window.Grids[0].DoGrouping('CritClassif,NomeCategoria,DtLanc,Banco,NrConta,DsHistorico')
            }, 300)
          }
          this.disableSearchButton = false
          resolve()
        }).catch((error) => {
          this.$root.$refs.notification.error(error)
          stopTreeGridLoading(this.gridId)
          this.disableSearchButton = false
          reject()
        })
      })
    },

    async openSelectBankAccountsModal () {
      if (this.data.bankAccounts.values.length > 0) {
        this.shown.bankAccounts = true
        return
      }
      const bankAccounts = await this.$store.dispatch('getBankAccounts', '/bankStatement/bankAccounts/list')
      this.data.bankAccounts.allBankAccounts = bankAccounts.data.data
      this.data.bankAccounts.showToggleInactiveAccounts = this.data.bankAccounts.allBankAccounts.find((bankAccount) => {
        return !bankAccount.ativo
      })
      this.data.bankAccounts.values = this.data.bankAccounts.allBankAccounts.filter((bankAccount) => {
        return bankAccount.ativo
      })
      const groups = await this.$store.dispatch('getEstablishmentGroups')
      this.groups = groups
      this.groups.push({
        id: 0,
        nome: this.$t('contaBancaria.labels.semGrupo')
      })
      this.shown.bankAccounts = true
    },

    showDetailsModal () {
      this.isOpenDetailsModal = true
    },

    closeDetailsModal () {
      this.isOpenDetailsModal = false
    },

    closeModal () {
      this.shown.bankAccounts = false
    },

    generateModalTabs () {
      let tabs = []
      // push tab details
      tabs.push({
        idFunctionalitie: null,
        idTabRoot: 'gridDetailsModal-tabDetails',
        idTabContent: 'tab-details-id',
        idLanc: this.detailsObj.mainValuesList[0].value,
        tabRef: 'tadDetailsGridModal',
        title: this.$t('modalDetalhesLanc.titulos.tabDetalhes'),
        icon: 'icon="tab-icon-font fa fa-info-circle',
        type: 'TabDetails',
        props: {
          mainValuesList: this.detailsObj.mainValuesList,
          monetaryValuesList: this.detailsObj.monetaryValuesList
        }
      })

      // push tab classification
      tabs.push({
        idFunctionalitie: null,
        idTabRoot: 'gridDetailsModal-tabClassification',
        idTabContent: 'tab-classification-id',
        idMovimento: this.detailsObj.mainValuesList[0].value,
        tabRef: 'tabClassificationGridModal',
        title: this.$t('modalDetalhesLanc.titulos.tabClassif'),
        icon: 'tab-icon-font fa fa-handshake-o',
        type: 'TabClassification',
        props: {
          mainValuesList: this.detailsObj.classificationValuesList
        }
      })

      if (this.detailsObj.idProcessamento) {
        // push tab Integrations
        tabs.push({
          idFunctionalitie: null,
          idTabRoot: 'gridDetailsModal-tabIntegrations',
          idTabContent: 'tab-integrations-id',
          idLanc: this.detailsObj.mainValuesList[0].value,
          tabRef: 'tadIntegrationGridModal',
          title: this.$t('modalDetalhesLanc.titulos.tabIntegracoes'),
          icon: 'tab-icon-font fa fa-share-alt',
          type: 'TabIntegrations',
          props: {
            loadIntegration: this.findIntegration,
            idProcessamento: this.detailsObj.idProcessamento,
            integrationValuesList: this.detailsObj.integrationValuesList
          }
        })
      }

      // push tab tasks
      tabs.push({
        idFunctionalitie: FunctionalitieIdEnum.TAREFAS,
        idTabRoot: 'gridDetailsModal-tabTasks',
        idTabContent: 'tab-tasks-id',
        idMovimento: this.detailsObj.mainValuesList[0].value,
        tabRef: 'tabTasksGridModal',
        title: this.$t('modalDetalhesLanc.titulos.tabTarefas'),
        icon: 'tab-icon-font fa fa-tasks',
        type: 'TabTasks',
        props: {
          idMovimento: this.detailsObj.mainValuesList[0].value,
          tipoMovimento: 'MovBan'
        }
      })

      this.modalDetailsTabs = tabs
    },

    findBankStatementHistory (id) {
      let data = {
        idBankStat: id,
        url: '/bankStatement/history'
      }
      return this.$store.dispatch('getHistoricBankStat', data)
    },

    findIntegration (id) {
      let data = {
        idProcessamento: id,
        url: '/processedFiles/getProcessedFilesById'
      }
      return this.$store.dispatch('getProcessedFiles', data)
    }
  },

  mounted () {
    // Listener para evento de atualização de dados dentro da modal de detalhes,
    // o que requer uma nova consulta para o relatório
    const self = this
    closeModal.$on('modalDetaisClose', (flag) => {
      if (flag) {
        self.showTreegrid = true
        startTreeGridLoading(self.gridId, self.getLoadingMessages())
        self.search()
        // Altera a flag que recarrega a treegrid após o recarregamento
        // para impedir que ela seja recarregada sempre após a primeira vez
        closeModal.$emit('taskChange', false)
      }
    })
  }
}
</script>

<style lang='css' scoped>
.input-button>button {
  margin: 24px 0 0 0;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  height: 36px;
  float: left;
}

#logDeAuditoriaWrapper {
  width: 100%;
}

#divTreeGridAuditoria {
  min-width: 100%;
  min-height: 500px;
}

.check {
  text-align: center;
}

.filterButton {
  width: 3vw;
  margin: 0px !important;
}

.col-search {
  width: 53.5%;
}

.search-button {
  min-width: 7vw;
}
</style>



// WEBPACK FOOTER //
// BankStatement.vue?751fd19c